import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    questions(data) {
        return axios.request({
            url: "mwap/questlist",
            method: "post",
            data
        });
    },
    submitQuestions(data) {
        return axios.request({
            url: "mwap/submitquests",
            method: "post",
            data
        });
    }
}
